export default "__VITE_ASSET__C9dpSQ5w__"